import React, { useState } from "react";
import { Box, Button, VStack, Heading, Input, InputGroup, Container, Spinner, HStack, Image } from "@chakra-ui/react";
import { LuUser, LuKey, LuArrowRight } from "react-icons/lu";

import Type from "../utilies/Types";
import { saveToCache, showToast } from "../utilies/Utility";
import { serviceLogin } from "../api/services/user";
import { useAppStore } from "../context/store";

function LogIn() {
  const username = useAppStore((s) => s.username);
  const password = useAppStore((s) => s.password);

  const setIsLoggedIn = useAppStore.getState().setIsLoggedIn;
  const setUsername = useAppStore.getState().setUsername;
  const setPassword = useAppStore.getState().setPassword;
  const setUserData = useAppStore.getState().setUserData;
  const setUserType = useAppStore.getState().setUserType;

  const [isLoginProgress, setIsLoginProgress] = useState(false);

  const loginServer = () => {
    setIsLoginProgress(true);
    serviceLogin({
      username: username,
      password: password,
    })
      .then((res) => {
        if (res.status) {
          if (
            res.data.roles?.includes(Type.ROLE.ADMIN) ||
            res.data.roles?.includes(Type.ROLE.REVIEWER) ||
            res.data.roles?.includes(Type.ROLE.SUPER_ADMIN) ||
            res.data.roles?.includes(Type.ROLE.ANNOTATOR) ||
            res.data.roles?.includes(Type.ROLE.VIEWER) ||
            res.data.roles?.includes(Type.ROLE.DIGITIZER)
          ) {
            saveToCache(Type.STORAGE.USERINFO, res.data);
            setUserData(res.data);
            setUserType(res.data.roles);
            setIsLoggedIn("true");
          } else {
            showToast("No permission", Type.NOTIFICATION.WARNING);
          }
        }
        setIsLoginProgress(false);
      })
      .catch((err) => {
        setIsLoginProgress(false);
        showToast(err.message, Type.NOTIFICATION.ERROR);
      });
  };

  const usernameInputListener = (value) => {
    setUsername(value.target.value);
  };

  const PasswordInputListener = (value) => {
    setPassword(value.target.value);
  };

  return (
    <Container width="full" py={12} height="100vh" display="flex" alignItems="center" justifyContent="center">
      <Box p={8} rounded="lg" boxShadow="lg" width="50%" w={{ base: "100%", sm: "90%", md: "70%", lg: "50%" }} maxW="xl">
        <VStack spacing={6} gap={5}>
          <HStack align="center">
            <Image userSelect="none" draggable={false} src="/assets/image/gatik-logo.png" alt="Logo" boxSize="65px" />
            <Heading size="4xl">Login</Heading>
          </HStack>

          <InputGroup startElement={<LuUser />}>
            <Input placeholder="Username" value={username} onChange={usernameInputListener} />
          </InputGroup>
          <InputGroup startElement={<LuKey />}>
            <Input placeholder="Password" type="password" value={password} onChange={PasswordInputListener} />
          </InputGroup>

          <Button colorScheme="blue" size="lg" w="full" marginTop={5} onClick={loginServer} disabled={isLoginProgress}>
            {isLoginProgress && <Spinner size="sm" />}
            {!isLoginProgress && (
              <>
                Log In <LuArrowRight />
              </>
            )}
          </Button>
        </VStack>
      </Box>
    </Container>
  );
}

export default LogIn;
